import React from "react";
import {
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Tooltip,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { withTranslation } from 'react-i18next';

export const FormRegistros = withTranslation()(function FormRegistros({
    id,
    registroTexto,
    registroNombre,
    registroObjetivo,
    registroPosicion,
    registroTipo,
    eliminarRegistroPaso,
    isAtBrowser,
    t,
}) {
    const [texto, setTexto] = React.useState(registroTexto);
    const [nombre, setNombre] = React.useState(registroNombre);
    const [objetivo, setObjetivo] = React.useState(registroObjetivo || "");
    const [posicion, setPosicion] = React.useState(registroPosicion);
    const [tipo, setTipo] = React.useState(registroTipo || "");

    function preventPaste(e) {
        e.preventDefault();
        return false;
    }

    return (
        <React.Fragment>
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
            >
                <Tooltip title={t('formRegistros.button.deleteRecord')} placement="top">
                    <IconButton
                        onClick={() => eliminarRegistroPaso(id)}
                        size="small"
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                    variant="outlined"
                    size="small"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    label={t('formRegistros.field.name')}
                    required
                    name="nombre"
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {isAtBrowser ? (
                    <FormControl
                        fullWidth
                        variant="outlined"
                        size="small"
                        required={isAtBrowser}
                    >
                        <InputLabel id="select-tipo-lbl">{t('formRegistros.select.windowLabel')}</InputLabel>
                        <Select
                            name="objetivo"
                            labelId="select-objetivo-lbl"
                            id="select-objetivo"
                            value={objetivo}
                            label={t('formRegistros.select.windowLabel')}
                            onChange={(e) => setObjetivo(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>{t('formRegistros.select.placeholder')}</em>
                            </MenuItem>
                            <MenuItem value="main">{t('formRegistros.select.main')}</MenuItem>
                            <MenuItem value="popup">{t('formRegistros.select.popup')}</MenuItem>
                        </Select>
                    </FormControl>
                ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                    variant="outlined"
                    size="small"
                    value={posicion}
                    onChange={(e) => setPosicion(e.target.value)}
                    label={t('formRegistros.field.position')}
                    name="posicion"
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    fullWidth
                    onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨"].includes(e.key) && e.preventDefault()}
                    onPaste={preventPaste}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <FormControl
                    fullWidth
                    variant="outlined"
                    size="small"
                    required={isAtBrowser}
                >
                    <InputLabel id="select-tipo-lbl">{t('formRegistros.select.typeLabel')}</InputLabel>
                    <Select
                        name="tipo"
                        labelId="select-tipo-lbl"
                        id="select-tipo"
                        value={tipo}
                        label={t('formRegistros.select.typeLabel')}
                        onChange={(e) => setTipo(e.target.value)}
                    >
                        <MenuItem value="">
                            <em>{t('formRegistros.select.placeholder')}</em>
                        </MenuItem>
                        <MenuItem value="javascript">{t('formRegistros.select.javascript')}</MenuItem>
                        <MenuItem value="regexp">{t('formRegistros.select.regexp')}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                    variant="outlined"
                    size="small"
                    value={texto}
                    onChange={(e) => setTexto(e.target.value)}
                    label={t('formRegistros.field.codeToExecute')}
                    required
                    name="texto"
                    type=""
                    multiline
                    fullWidth
                    minRows={3}
                    maxRows={6}
                />
            </Grid>
        </React.Fragment>
    );
});
